import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { queryForcedRankingStrategy, QUERY_KEY } from 'src/queries/queryForcedRankingStrategy';

type Strategy = Models.IngestConfigApi.ForcedRankings.ForcedRankingStrategy;
type QueryKey = App.ForcedRankings.StrategyLookupQueryKey;

export const useQueryForcedRankingStrategy = (
    accessToken: string | undefined | false,
    strategyName: string,
    options?: UseQueryOptions<Strategy, Error, Strategy, App.ForcedRankings.StrategyLookupQueryKey>,
): UseQueryResult<Strategy, Error> => useQuery<Strategy, Error, Strategy, QueryKey>(
    [QUERY_KEY, accessToken, strategyName],
    queryForcedRankingStrategy,
    options,
);
